import { render } from "./StepDetails.vue?vue&type=template&id=4037f7b9"
import script from "./StepDetails.vue?vue&type=script&lang=js"
export * from "./StepDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__